import React, { useState, useRef, useEffect } from "react";
import { EasyBefore } from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/Profile.css";
import ProfileTab from "./ProfileTab";
import { useForm } from "../../hooks/Form";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { setSuccess, clearMessage } from "../../store/reducers/globalReducers";
import {
	useEditDriverProfileMutation,
	useGetDriverProfileQuery,
} from "../../store/services/EditDrivingService";
import Spinner from "../../utils/Loader";

const EditDriverDetail = () => {
	let { data, isLoading } = useGetDriverProfileQuery();
	const [errors, setErrors] = useState([]);
	const { state, onChange, setState } = useForm({
		date: "",
		age: "",
		address: "",
		driver_license_info: "",
		rut: "",
		company_details: "",
		revenue: "",
	});
	const ref = useRef();
	let { success } = useSelector((state) => state.globalReducer);
	const [driverProfileEdit, response] = useEditDriverProfileMutation();
	const dispatch = useDispatch();
	let navigate = useNavigate();
	let driverProfile = data?.response?.data;

	useEffect(() => {
		setState(driverProfile);
	}, [isLoading === true]);

	const SaveChanges = (e) => {
		e.preventDefault();
		if (state?.rut?.length < 12 || state?.rut?.length > 12) {
			ToastMessage("Please Enter only 12 number in Rut");
		} else {
			const FormDatas = new FormData();
			FormDatas.append("dob", state.date);
			FormDatas.append("age", state.age);
			FormDatas.append("address", state.address);
			FormDatas.append("driver_license_info", state.driver_license_info);
			FormDatas.append("rut", state.rut);
			FormDatas.append("company_details", state.company_details);
			FormDatas.append("revenue", state.revenue);
			driverProfileEdit(FormDatas);
		}
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(
				success === "responseMessages.driverProfileAdded"
					? "Profile Update Successfully"
					: success,
			);
			state.date = "";
			state.age = "";
			state.address = "";
			state.driver_license_info = "";
			state.rut = "";
			state.company_details = "";
			state.revenue = "";
			navigate("/driver-profile");
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);

	return (
		<>
			{!isLoading ? (
				<>
					<div className="services Account">
						{/* Header */}
						<Header />
						{/* Header */}

						{/* Easy Plan Sec Start Here */}
						<section className="easy-plan mt-5">
							<div className="right-before">
								<figure>
									<img src={EasyBefore} alt="" className="img-fluid" />
								</figure>
							</div>
							<div className="container mt-5">
								<div className="row mb-3">
									<div className="col-lg-12 text-left">
										<p>
											Home{" "}
											<span className="fa fa-chevron-right chevron_right">
												{" "}
											</span>{" "}
											Profile
										</p>
									</div>
								</div>
							</div>
						</section>

						{/* accout section starts*/}
						<section className="profile_section">
							<div className="container">
								<div className="row">
									<div className="col-lg-3">
										<ProfileTab />
									</div>
									<div className="col-lg-9">
										<div className="InfoDetails">
											<h3 className="heading_Account">Edit Driver's details</h3>
											<div className="row">
												<div className="col-lg-6 my-2">
													<input
														type="text"
														placeholder="D.O.B"
														ref={ref}
														onFocus={() => (ref.current.type = "date")}
														required
														onChange={onChange}
														value={state?.date}
														name="date"
														// min={new Date().toISOString().split("T")[0]}
														className="inpt_field"
													/>
													{errors && errors?.date && (
														<span className="errorMessage">
															<p>{errors && errors?.date}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 my-2">
													<input
														type="text"
														className={`${
															errors && errors?.age
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														placeholder="Age"
														name="age"
														value={state?.age}
														onChange={onChange}
													/>
													{errors && errors?.age && (
														<span className="errorMessage">
															<p>{errors && errors?.age}</p>
														</span>
													)}
												</div>

												<div className="col-lg-12 my-2">
													<input
														type="text"
														className={`${
															errors && errors?.address
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														placeholder="Address"
														name="address"
														value={state?.address}
														onChange={onChange}
													/>
													{errors && errors?.address && (
														<span className="errorMessage">
															<p>{errors && errors?.address}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 my-2">
													<input
														type="text"
														className={`${
															errors && errors?.driver_license_info
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														placeholder="Driver’s License Info"
														name="driver_license_info"
														value={state?.driver_license_info}
														onChange={onChange}
													/>
													{errors && errors?.driver_license_info && (
														<span className="errorMessage">
															<p>{errors && errors?.driver_license_info}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 my-2">
													<input
														type="text"
														placeholder="RUT"
														className={`${
															errors && errors?.rut
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														name="rut"
														value={state?.rut}
														onChange={onChange}
													/>
													{errors && errors?.rut && (
														<span className="errorMessage">
															<p>{errors && errors?.rut}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 my-2">
													<input
														type="text"
														className={`${
															errors && errors?.company_details
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														placeholder="Company Details"
														name="company_details"
														value={state?.company_details}
														onChange={onChange}
													/>
													{errors && errors?.company_details && (
														<span className="errorMessage">
															<p>{errors && errors?.company_details}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 my-2">
													<input
														type="text"
														className={`${
															errors && errors?.revenue
																? "SetErrorshow inpt_field"
																: "inpt_field"
														}`}
														placeholder="Revenue"
														name="revenue"
														value={state?.revenue}
														onChange={onChange}
													/>
													{errors && errors?.revenue && (
														<span className="errorMessage">
															<p>{errors && errors?.revenue}</p>
														</span>
													)}
												</div>

												<div className="col-lg-6 mt-3">
													<button
														class="flit-btn bt-prof-green"
														onClick={SaveChanges}
													>
														Save Changes
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* accout section ends*/}

						{/* Footer */}
						<Footer />
						{/* Footer */}
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default EditDriverDetail;
